export class ClearMessages {
  static readonly type = '[Message Center] Clear Messages';
}
